module.exports = __webpack_public_path__ + "img/agrobud-logo.105ddafc.png";